import { AfterContentInit } from '@angular/core';
import { Component } from '@angular/core';
import { ContentChildren } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { forwardRef } from '@angular/core';
import { Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { OnDestroy } from '@angular/core';
import { QueryList } from '@angular/core';
import { UIRadioComponent } from './radio.component';

import { noop ,  Subscription ,  merge } from 'rxjs';

const RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UIRadioGroupComponent),
    multi: true
};

@Component({
    selector: 'ui-radio-group',
    template: '<ng-content></ng-content>',
    styleUrls: ['radio.component.scss'],
    providers: [RADIO_CONTROL_VALUE_ACCESSOR]
})
export class UIRadioGroupComponent implements AfterContentInit, ControlValueAccessor, OnDestroy {

    private _onChange: Function = noop;

    private _onTouched: Function = noop;

    private _radioSubscription: Subscription;

    @Input()
    disabled: boolean;

    @Input()
    name: string;

    @ContentChildren(UIRadioComponent)
    radios: QueryList<UIRadioComponent>;

    ngAfterContentInit(): void {
        const emitters = merge(...this.radios.map(option => option.onCheckRadio));
        this._radioSubscription = emitters.subscribe((radio: UIRadioComponent) => {
            this._onCheck(radio);
        });
    }

    ngOnDestroy(): void {
        this._destroyRadios();
    }

    private _onCheck(selectedRadio: UIRadioComponent) {
        this.radios.forEach(radio => {
            radio.checked = (radio === selectedRadio);
        });
        this._onChange(selectedRadio.value);
        this._onTouched();
    }

    private _setOptionByValue(value: any) {
        this.radios.forEach(radio => {
            if (radio.value === value) {
                this._onCheck(radio);
            }
        });
    }

    private _destroyRadios() {
        if (this._radioSubscription) {
            this._radioSubscription.unsubscribe();
            this._radioSubscription = null;
        }
    }

    writeValue(value: any): void {
        if (this.radios) {
            this._setOptionByValue(value);
        }
    }

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        if (this.radios) {
            this.radios.forEach(radio => {
                radio.disabled = disabled;
            });
        }
    }

}